<template>
  <div class="home">
    <login-form v-if="!authUser"/>
    <div v-else>
      <app-header/>
      <add-item v-if="currentQuery"/>
      <items-list/>
    </div>
    <app-menu v-if="appMenuOpen"/>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import LoginForm from '@/components/LoginForm'
  import ItemsList from '@/components/ItemsList'
  import AddItem from '@/components/AddItem'
  import AppHeader from '@/components/AppHeader'
  import AppMenu from '@/components/AppMenu'

  export default {
    components: {AppMenu, AppHeader, AddItem, ItemsList, LoginForm},
    computed: {
      ...mapState(['authUser', 'currentQuery', 'appMenuOpen'])
    }
  }
</script>

